<template>
  <CContainer>
    <CRow>
      <h6>
        En este módulo podrá realizar un Pedido realizando busqueda entre el catálogo de productos asignados al cliente.
      </h6>
    </CRow>
    <ImageGallery :cartMode="true" :data="products"/>
    <CElementCover v-if="loading"/>
  </CContainer>
</template>

<script>
  import { dataGridProductosPedidos } from '../../api'
  import ImageGallery from '../containers/ImageGallery'

  export default {
    name: "Orders",
    data() {
      return {
        category: '',
        subcategory: '',
        brand: '',
        search: '',
        products: [],
        loading: false
      }
    },
    components: {
      ImageGallery
    },
    methods: {
      async getData() {
        try {
          this.loading = true
          const {response} = await dataGridProductosPedidos(this, this.$store.state.user.data.id_Directorio)
          this.products = response
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
    },
    mounted(){
      this.getData()
    }
  }
</script>